// Imports => Constants
import { ENDPOINTS } from '@constants';

export class BalanceApi {
  constructor(Client, NoBaseClient, config) {
    this.Client = Client;
    this.config = config;
  }

  get = (params) => {
    return this.Client.get(`${ENDPOINTS.BALANCE.GET}`, { params }).then(
      (response) => response.data.data
    );
  };

  get_profile = (uid, params) => {
    return this.Client.get(ENDPOINTS.BALANCE.GET_PROFILE(uid), { params }).then(
      (response) => response.data.data
    );
  };

  withdraw = (params) => {
    return this.Client.post(
      ENDPOINTS.BALANCE.WITHDRAW,
      params,
    ).then((response) => response.data.data);
  };
}

export default BalanceApi;